import { defineComponent } from "vue";
import { Container } from "aurelia-dependency-injection";
import { mapState } from "pinia";

import { ReferralService } from "../../../../../../services/referral-service";
import { PAGE_FAIL_RESPONSE } from "../../../../../CentralIntake/Inquiry/CentralInquiry";
import { IPageCallbackResult } from "../../../../../../resources-vue/vue-interfaces/i-page-container";
import { useHospiceConvertToPending } from "../../../store/useHospiceConvertToPending";
import { PatientService } from "../../../../../../services/patient.service";
import { ServiceLocation } from "../../../../../../resources-vue/vue-models/service-locations";

import Pagination from "../../../../../../resources-vue/vue-elements/Pagination/Pagination.vue";
import FormSection from "../../../../../../resources-vue/vue-custom-elements/FormSection/FormSection.vue";
import ErrorMessageHandler from "../../../../../../resources-vue/vue-custom-elements/ErrorMessageHandler/ErrorMessageHandler.vue";
import ServiceLocationRow from "./ServiceLocationRow/ServiceLocationRow.vue";
import AddServiceLocationForm from "./AddServiceLocationForm/AddServiceLocationForm.vue";

export default defineComponent({
    components: {
        Pagination,
        FormSection,
        ErrorMessageHandler,
        ServiceLocationRow,
        AddServiceLocationForm
    },

    data(vm) {
        return {
            _patientService: null,
            _referralService: null,
            showServiceForm: false as boolean,
            page: null,
            isLoading: false as boolean,
            isError: false as boolean,
            columns: 4 as number,
            serviceList: null,
            serviceLocationList: null,
            newServiceForm: new ServiceLocation({})
        };
    },
    computed: {
        ...mapState(useHospiceConvertToPending, ["accountId", "application", "patientDetails", "patientId"]),
        loadingCount() {
            return this.page?.items?.length > 0 ? this.page.items.length() : 5;
        },
        hasData() {
            return this.page?.itemCount > 0;
        }
    },
    created() {
        this._referralService = Container.instance.get(ReferralService);
        this._patientService = Container.instance.get(PatientService);
    },

    mounted() {
        this.serviceLocationList = this.$refs.serviceLocationList;
        this.resetList();
    },

    methods: {
        async pageChangedCallback(pageNumber: number, pageSize: number): Promise<IPageCallbackResult> {
            try {
                this.isError = false;
                let data = await this._patientService.getServiceLocations(this.patientId, {
                    application: Number(this.application),
                    accountId: this.accountId,
                    page: pageNumber,
                    pageSize: pageSize
                });
                this.page = data;
                return {
                    totalPageCount: data.pageCount,
                    success: data.itemCount > 0,
                    totalCount: data.itemCount
                };
            } catch (e) {
                console.error(e);
                this.isError = true;
                return PAGE_FAIL_RESPONSE;
            }
        },
        resetList() {
            this.serviceLocationList.reset();
        },
        openServiceLocationForm() {
            this.showServiceForm = true;
        },
        closeServiceForm() {
            this.showServiceForm = false;
            this.newServiceForm = new ServiceLocation({});
        }
    }
});
